import { render } from "./ForeignTrip.vue?vue&type=template&id=b5219f2e"
import script from "./ForeignTrip.vue?vue&type=script&lang=js"
export * from "./ForeignTrip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__